document.addEventListener('DOMContentLoaded',()=>{
  const header=document.querySelector('[data-sticky-header]');
  const onScroll=()=>{ if(header){ header.classList.toggle('is-scrolled', window.scrollY>8); } };
  onScroll(); window.addEventListener('scroll',onScroll,{passive:true});

  const btn=document.querySelector('[data-menu-toggle]');
  const menu=document.querySelector('[data-menu]');
  if(btn&&menu){
    btn.addEventListener('click',()=>{
      const open=menu.classList.toggle('open');
      btn.classList.toggle('is-open',open);
      btn.setAttribute('aria-expanded',open?'true':'false');
    });
    menu.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{
      menu.classList.remove('open'); btn.classList.remove('is-open'); btn.setAttribute('aria-expanded','false');
    }));
  }

  const revealEls=document.querySelectorAll('.reveal,.reveal-item,.category-card,.why-cards div,.guide-grid div,.review-grid blockquote,.offer-card');
  if('IntersectionObserver' in window){
    const io=new IntersectionObserver((entries)=>{
      entries.forEach((entry)=>{ if(entry.isIntersecting){ entry.target.classList.add('in-view'); io.unobserve(entry.target); } });
    },{threshold:.12,rootMargin:'0px 0px -30px 0px'});
    revealEls.forEach(el=>io.observe(el));
  } else { revealEls.forEach(el=>el.classList.add('in-view')); }

  const canHover=window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  if(canHover){
    const cards=document.querySelectorAll('.product-card,.category-card');
    cards.forEach((card)=>{
      card.addEventListener('mousemove',e=>{
        const r=card.getBoundingClientRect();
        const x=(e.clientX-r.left)/r.width-.5;
        const y=(e.clientY-r.top)/r.height-.5;
        card.style.transform=`perspective(900px) rotateX(${y*-3.5}deg) rotateY(${x*3.5}deg) translateY(-5px)`;
      });
      card.addEventListener('mouseleave',()=>{card.style.transform=''});
    });
  }
});
